<template>
  <div class="group-comment-sidebar">
    <b-sidebar position="absolute"
               :right="true"
               :fullheight="true"
               :overlay="false"
               :open="open"
               @close="cancel">
      <div class="calendar-entry-form" v-if="agreement && agreement.employee">
        
        <div class="calendar-entry-sidebar-field">
          <div class="sidebar-field-header">
            {{ headerText }}
          </div>
        </div>
        
        <div class="sidebar-body">
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Dage ins.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="agreement.daysCalculated" :controls="false" @input="modelUpdated" />
            </div>
          </div>
        </div>
        <div class="sidebar-footer">
          <div class="sidebar-footer-controls">
            <b-button @click="update" class="is-blue" :loading="loading">Opdater</b-button>
            <b-button @click="cancel" class="is-text">Annuller</b-button>
          </div>
          <div class="sidebar-footer-updated content p-2 has-text-centered">
            {{ latestUpdateText }}
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import APISTATE from '../../enums/APISTATE';

export default {
  name: 'agreement-sidebar',
  data: () => ({
  }),
  computed: {
    ...mapGetters('agreementStore', ['agreement', 'agreementApiState']),
    headerText() {
      if(!this.agreement?.employee){
        return null;
      }

      return `Overenskomst ${this.agreement.employeeName} - ${this.agreement.employee.number}`;
    },
    latestUpdateText() {
      if (!this.agreement?.employee) {
        return null;
      }

      const duration = moment().diff(moment(this.agreement._LatestUpdate), "milliseconds");
      const durationText = duration > 0 ? moment.duration(duration).humanize() : '';

      return `Opdateret ${durationText} siden af ${this.agreement?._UpdatedByName}`;
    },
    loading() {
      return this.agreementApiState === APISTATE.LOADING;
    },
    open() {
      return this.agreement?.employee !== undefined;
    }
  },
  methods: {
    ...mapActions('agreementStore', ['cancelEditingAgreement', 'agreementUpdate']),
    update() {
      this.agreementUpdate(this.agreement);
    },
    cancel() {
      this.cancelEditingAgreement();
    },
    modelUpdated() {
      this.$nextTick(() => {        
        if(this.agreement && this.agreement.id) {
          this.$emit('onChange', this.agreement);
        }
      });
    },
  },
  watch: {
    'agreement'(newValue) {
      this.model = {...newValue};
    }
  }
}
</script>

<style lang="scss">
.group-comment-sidebar {
  .group-comment-sidebar-contents {
    flex: 1 0 auto;
    border: 3px solid $border;

    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: stretch;

    .sidebar-header {
      flex: 0 1 auto;
      padding: 20px;
    }
    .sidebar-body {
      flex: 1 0 auto;
      padding: 0 10px;
      .is-expanded,
      .textarea {
        height: 100%;
      }
    }
    .sidebar-footer {
      flex: 0 1 auto;
      
      .sidebar-footer-controls {
        padding: 20px;

      }
      .sidebar-footer-updated {
        background-color: $border;
      }
    }
  }
}
</style>